import Anz from "../../../assets/logos/Anz.svg";
import DownloadCaseStudy from "../../../CaseStudy/components/DownloadCaseStudy";

export const CaseStudySection = () => {
  return (
    <div className="case_study">
      <img src={Anz.src} alt="ANZ" loading="eager" width="96" height="31" />
      <p>
        ANZ is providing conditional approval on unsecured lending for small business customers in
        less than 20 minutes via ANZ GoBiz.
      </p>
      <DownloadCaseStudy
        autoWidth
        variant="inverted"
        url={"/ANZ SME Lending Case Study.pdf"}
        data-test-id="home-hero-button"
      >
        Download Case Study
      </DownloadCaseStudy>
    </div>
  );
};
